export enum OrderStatusEnum {
  Normal = 1,
  Event = 2,
  Hybrid = 3,
  Paid_Sample = 4,
  Unoaid_Sample = 5,
  Storage = 6,
}

export const OrderStatus = [
  { id: 1, value: "Normal" },
  { id: 2, value: "Event" },
  { id: 3, value: "Hybrid" },
  { id: 4, value: "Paid Sample" },
  { id: 5, value: "Unoaid Sample" },
  { id: 6, value: "Storage" },
];

export interface OrderStatusFilter {
  id: number;
  label: string;
  count: number;
}

export const GstPercentage: number[] = [0, 3, 5, 18, 28, 40];
